import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import axios from 'axios';
import Spinner from '../Spinner';

export default function Proyectos() { 
    
    const API_BASE = "https://www.ies21.edu.ar/hackaton3d/";

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const result = await axios(`${API_BASE}projects.php`);
                setData(result.data.results);
            }catch (error) {
                setIsLoading(false);
            }
            setIsLoading(false);
        };
        fetchData();
        // eslint-disable-next-line
    }, []);


  return (
    <div className="row">
        {isLoading ? <Spinner txt="Buscando proyectos..." /> : 
            <React.Fragment>
                {data.map(item => (
                    <div className="col-md-4" key={item.id}>
                        <div className="card">
                            <img className="card-img-top" src={item.upload_name_imagen} alt={item.titulo} />
                            <div className="card-body text-center lin-inf">
                                <h5 className="card-title">{item.titulo}</h5>
                                <p className="card-text">{item.descripcion}</p>
                                <p className="card-text"><strong>Autores</strong><br />
                                {item.autores}</p>
                                <NavLink exact to={`proyecto/${item.id}`} className="btn btn-primary mt-2">VER PROYECTO</NavLink>
                            </div>
                        </div>
                    </div>            
                ))}
            </React.Fragment>
        }
    </div> 
  );
}